import React from "react";
import {FaArrowLeft, FaPlus} from "react-icons/fa";
import {FaChartBar} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

export default function Header({ onBack, onShowStats, onAddNew }) {
    const navigate = useNavigate();
    return (
        <header id="header" className="bg-white px-4 py-4 fixed top-0 left-0 right-0 shadow-sm z-50">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <button onClick={onBack} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors">
                        <div className=" text-gray-600">
                            <FaArrowLeft></FaArrowLeft>
                        </div>
                    </button>
                    <h1 className="text-xl font-bold text-gray-900">My Signals</h1>
                </div>
                <div className="flex items-center space-x-3">
                    <button onClick={onShowStats} className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 hover:bg-blue-100 transition-colors">
                        <div className="text-blue-500">
                            <FaChartBar></FaChartBar>
                        </div>
                    </button>
                    <button onClick={() => navigate("/createSignal")} className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary hover:bg-primary/90 transition-colors">
                        <div className=" text-white">
                            <FaPlus></FaPlus>
                        </div>
                    </button>
                </div>
            </div>
        </header>
    );
}
